export const CONTACT = {
  company: "S.C. AN CONTAB AUDIT S.R.L.",
  person: "Dragoș Aldea",
  address: "Aleea Borcea, nr. 6, bl. 16, sc. C, ap. 83, Sector 4, București",
  phone: "0736 382 549",
  phoneHref: "tel:+40736382549",
  email: "contact@ancontab.ro",
  website: "www.ancontab.ro",
  websiteHref: "http://www.ancontab.ro",
  schedule: "Luni – Vineri: 09:00 – 18:00",
  mapsEmbed:
    "https://www.google.com/maps?q=Aleea+Borcea+6+Sector+4+Bucuresti&output=embed",
};

export const NAV_LINKS = [
  { label: "Acasă", href: "#acasa" },
  { label: "Despre noi", href: "#despre" },
  { label: "Servicii", href: "#servicii" },
  { label: "Pachete", href: "#pachete" },
  { label: "Industrii", href: "#industrii" },
  { label: "Testimoniale", href: "#testimoniale" },
  { label: "Întrebări Frecvente", href: "#faq" },
];

export const LEGAL_LINKS = [
  { label: "Termeni și condiții", to: "/termeni-si-conditii" },
  { label: "Politica de confidențialitate", to: "/politica-de-confidentialitate" },
  { label: "Politica de cookies", to: "/politica-de-cookies" },
];

export const SOCIALS = [
  { type: "facebook", href: "https://www.facebook.com/ancontab", label: "Facebook" },
  { type: "linkedin", href: "https://www.linkedin.com/in/an-contab-audit-2b481886", label: "LinkedIn" },
  { type: "x", href: "https://x.com/AnContab", label: "X" },
];

export const HERO_FEATURES = [
  "Membră CECCAR",
  "Consultanți fiscali autorizați",
  "Digitalizare completă",
  "Suport rapid",
];

export const STATS = [
  { value: 20, suffix: "+", label: "ani experiență" },
  { value: 500, suffix: "+", label: "clienți" },
  { value: 1000, suffix: "+", label: "declarații depuse anual" },
  { value: 99, suffix: "%", label: "clienți mulțumiți" },
];

export const SERVICES = [
  { icon: "BookOpenCheck", title: "Contabilitate completă", desc: "Evidență contabilă riguroasă, conformă cu legislația în vigoare." },
  { icon: "Landmark", title: "Fiscalitate", desc: "Optimizare fiscală și conformitate totală cu ANAF." },
  { icon: "Wallet", title: "Salarizare", desc: "Statul de plată, contracte și raportări REVISAL la timp." },
  { icon: "FileText", title: "Declarații fiscale", desc: "Întocmirea și depunerea corectă a tuturor declarațiilor." },
  { icon: "TrendingUp", title: "Consultanță financiară", desc: "Strategii financiare care susțin creșterea afacerii." },
  { icon: "Building2", title: "Înființări firme", desc: "Deschidem afacerea ta rapid, fără birocrație complicată." },
  { icon: "Archive", title: "Lichidări firme", desc: "Proceduri de lichidare gestionate corect, de la A la Z." },
  { icon: "BarChart3", title: "Bilanțuri contabile", desc: "Situații financiare clare și analize de performanță." },
  { icon: "Scale", title: "Reprezentare instituții", desc: "Te reprezentăm în fața ANAF și a instituțiilor statului." },
  { icon: "Settings2", title: "Optimizare procese", desc: "Digitalizăm și eficientizăm fluxurile tale financiare." },
];

export const INDUSTRIES = [
  { icon: "Building", title: "SRL" },
  { icon: "User", title: "PFA" },
  { icon: "HeartHandshake", title: "ONG" },
  { icon: "Rocket", title: "Startup" },
  { icon: "ReceiptText", title: "Companii plătitoare TVA" },
  { icon: "Receipt", title: "Companii fără TVA" },
  { icon: "Users", title: "Companii cu angajați" },
  { icon: "Laptop", title: "Freelanceri" },
];

export const PACKAGES = [
  {
    name: "IMM Start",
    price: "299",
    from: "Începând de la",
    featured: false,
    features: [
      "Contabilitate de bază",
      "Declarații fiscale",
      "Suport prin email",
      "Consultanță periodică",
    ],
  },
  {
    name: "IMM Long",
    price: "599",
    from: "Începând de la",
    featured: true,
    badge: "Cel mai ales",
    features: [
      "Toate beneficiile IMM Start",
      "Consultanță extinsă",
      "Salarizare",
      "Raportări lunare",
      "Suport prioritar",
    ],
  },
  {
    name: "IMM Premium",
    price: "1199",
    from: "Începând de la",
    featured: false,
    features: [
      "Contabilitate completă",
      "Consultanță fiscală permanentă",
      "Raportări personalizate",
      "Suport prioritar",
      "Manager dedicat",
      "Răspuns rapid",
    ],
  },
];

export const WHY = [
  { icon: "Award", title: "Experiență", desc: "Peste două decenii de expertiză contabilă și fiscală." },
  { icon: "MonitorSmartphone", title: "Digitalizare", desc: "Instrumente moderne pentru acces rapid la datele tale." },
  { icon: "Zap", title: "Rapiditate", desc: "Răspundem prompt și respectăm întotdeauna termenele." },
  { icon: "Eye", title: "Transparență", desc: "Fără costuri ascunse. Comunicare clară și onestă." },
  { icon: "Headset", title: "Suport dedicat", desc: "Un consultant care îți cunoaște afacerea în detaliu." },
  { icon: "Puzzle", title: "Soluții personalizate", desc: "Adaptăm serviciile la nevoile reale ale companiei tale." },
];

export const PROCESS = [
  { step: "01", title: "Analizăm afacerea", desc: "Înțelegem modelul tău de business și obiectivele financiare." },
  { step: "02", title: "Stabilim soluția potrivită", desc: "Construim un plan de servicii adaptat nevoilor tale." },
  { step: "03", title: "Preluăm documentele", desc: "Colectăm și organizăm documentele, digital și securizat." },
  { step: "04", title: "Gestionăm contabilitatea", desc: "Ne ocupăm de evidența contabilă și obligațiile fiscale." },
  { step: "05", title: "Raportăm constant", desc: "Primești rapoarte clare, la zi, despre situația financiară." },
  { step: "06", title: "Dezvoltăm împreună afacerea", desc: "Te consiliem pentru decizii financiare care aduc creștere." },
];

export const TESTIMONIALS = [
  { name: "Andrei Popescu", role: "Fondator, TechNova SRL", quote: "Colaborarea cu AN CONTAB AUDIT ne-a dat liniștea de care aveam nevoie. Totul e la zi, transparent și explicat pe înțelesul nostru." },
  { name: "Maria Ionescu", role: "Administrator, GreenLeaf SRL", quote: "Profesioniști adevărați. Ne-au digitalizat complet contabilitatea și economisim ore întregi în fiecare lună." },
  { name: "Cristian Dumitru", role: "CEO, BuildPro Group", quote: "Rapiditate și seriozitate. Recomand oricărei companii care vrea un partener financiar de încredere." },
  { name: "Elena Marin", role: "Freelancer & Consultant", quote: "Ca PFA, aveam mereu întrebări. Acum am un consultant dedicat care îmi răspunde imediat. Excelent!" },
  { name: "Popa Andrei", role: "Freelancer", quote: "Faptul că am colaborat într-un mod excepțional cu echipa AN CONTAB AUDIT mă determină să o recomand cu responsabilitate și căldură!" },
];

export const FAQS = [
  { q: "Ce servicii de contabilitate oferă AN CONTAB AUDIT?", a: "Oferim servicii complete: contabilitate financiară, salarizare, fiscalitate, declarații, bilanțuri, consultanță financiară, înființări și lichidări de firme, precum și reprezentare în fața instituțiilor statului." },
  { q: "Lucrați cu firme din toată România?", a: "Da. Datorită proceselor digitalizate, deservim companii din întreaga Românie, indiferent de localitate, prin transmiterea securizată a documentelor." },
  { q: "Cât costă serviciile de contabilitate?", a: "Prețurile pornesc de la 299 Lei + TVA pentru pachetul IMM Start. Tariful final depinde de volumul de documente, numărul de angajați și complexitatea activității." },
  { q: "Sunteți autorizați CECCAR?", a: "Da. Suntem membri CECCAR și ai Camerei Consultanților Fiscali, cu asigurare profesională, ceea ce garantează calitatea și legalitatea serviciilor." },
  { q: "Pot schimba contabilul actual cu AN CONTAB AUDIT?", a: "Absolut. Ne ocupăm de tot procesul de preluare a evidenței contabile de la contabilul anterior, fără bătăi de cap pentru tine." },
  { q: "Cum transmit documentele contabile?", a: "Poți transmite documentele digital, prin platformele noastre securizate, sau fizic. Recomandăm varianta digitală pentru rapiditate și siguranță." },
  { q: "Oferiți servicii de salarizare?", a: "Da. Ne ocupăm de state de plată, contracte de muncă, raportări REVISAL, declarații și toate obligațiile legate de angajați." },
  { q: "Cât de repede răspundeți la solicitări?", a: "Suportul rapid este un principiu de bază pentru noi. La pachetele cu suport prioritar, răspundem în cel mai scurt timp posibil." },
  { q: "Mă ajutați la înființarea unei firme noi?", a: "Da. Te ghidăm prin tot procesul de înființare a firmei, alegerea codurilor CAEN și a regimului fiscal potrivit afacerii tale." },
  { q: "Ce se întâmplă în cazul unui control ANAF?", a: "Te reprezentăm și te asistăm în relația cu ANAF și alte instituții, pregătind documentația necesară și asigurând conformitatea." },
];

export const BADGES = ["CECCAR", "Camera Consultanților Fiscali", "Asigurări profesionale"];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  about: "https://images.unsplash.com/photo-1551135049-8a33b5883817?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  why: "https://images.pexels.com/photos/7433930/pexels-photo-7433930.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
};
